import { theme } from '@chakra-ui/core';

export default {
  ...theme,
  fonts: {
    heading: "'Montserrat', sans-serif",
    body: "'Montserrat', sans-serif",
    mono: "'Montserrat', monospace"
  },
  fontSizes: {
    main: '24px',
    xs: '0.75rem',
    sm: '0.875rem',
    md: '1rem',
    lg: '1.125rem',
    xl: '1.25rem',
    '2xl': '1.5rem',
    '3xl': '1.875rem',
    '4xl': '2.25rem',
    '5xl': '3rem',
    '6xl': '4rem',
    mega: '100px'
  },
  fontWeights: {
    ...theme.fontWeights,
    normal: 400,
    medium: 500,
    semibold: 600,
    bold: 700
  }
};
